import * as React from 'react';
import { IconChevronLeft16 } from '@cian/ui-kit/icons';
import * as styles from './RoundArrowLeft.css';

interface IRoundArrowRightProps {
  onClick(): void;
}

export const RoundArrowLeft: React.FC<IRoundArrowRightProps> = ({ onClick }) => {
  return (
    <div className={styles['arrow']} onClick={onClick}>
      <IconChevronLeft16 color="gray_icons_100" />
    </div>
  );
};
